import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './inspection-history.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const InspectionHistoryDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const inspectionHistoryEntity = useAppSelector(state => state.inspectionHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="inspectionHistoryDetailsHeading">
          <Translate contentKey="fleetSenseApp.inspectionHistory.detail.title">InspectionHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{inspectionHistoryEntity.id}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="fleetSenseApp.inspectionHistory.created">Created</Translate>
            </span>
          </dt>
          <dd>{inspectionHistoryEntity.created ? <TextFormat value={inspectionHistoryEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="fleetSenseApp.inspectionHistory.status">Status</Translate>
            </span>
          </dt>
          <dd>{inspectionHistoryEntity.status}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.inspectionHistory.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{inspectionHistoryEntity.truckImplement ? inspectionHistoryEntity.truckImplement.id : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.inspectionHistory.user">User</Translate>
          </dt>
          <dd>{inspectionHistoryEntity.user ? inspectionHistoryEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.inspectionHistory.inspection">Inspection</Translate>
          </dt>
          <dd>{inspectionHistoryEntity.inspection ? inspectionHistoryEntity.inspection.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/inspection-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/inspection-history/${inspectionHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InspectionHistoryDetail;
